export default {
  contacts: [],
  activeChat: {},
  messages: [],
  showChats: true,
  showContacts: true,
  avatar: require("../../assets/images/contacts/avatar.png"),
  agentMessages: [],
  searchTerm: "",
  searchResults: [],
  refreshPage: false,
  expStatus: [],
  audiencecheckbox: [],
  filterContact: [],
  checktrue: false,
};
